import * as Yup from 'yup';
import { EFormTags } from '../../../../shared/interfaces/form-interfaces';

export const form = [
  {
    id: 'NewPasswordForm',
    items: [
      {
        name: 'token',
        type: 'text',
        label: 'Token',
        tag: EFormTags.textField,
      },
      {
        name: 'password',
        type: 'password',
        label: 'Senha',
        tag: EFormTags.textField,
      },
      {
        name: 'password2',
        type: 'password',
        label: 'Confirmar senha',
        tag: EFormTags.textField,
      },
    ],
  },
];

export const schema = Yup.object().shape({
  token: Yup.string().required().min(6).max(6),
  password: Yup.string().min(6, 'No mínimo 6 dígitos'),
  password2: Yup.string()
    .min(6, 'No mínimo 6 dígitos')
    .oneOf([Yup.ref('password'), null], 'Senhas não coincidem'),
});

export const initialData = {
  token: '',
  password: '',
  password2: '',
};
